import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
var HearingAidOptionsPage = lazy(function () { return import('./pages/HearingAidOptionsPage'); });
var HearingAidSimulatorPage = lazy(function () { return import('./pages/HearingAidSimulatorPage'); });
var WelcomePage = lazy(function () { return import('./pages/WelcomePage'); });
var SetupPage = lazy(function () { return import('./pages/SetupPage'); });
var AgeStep = lazy(function () { return import('./pages/AgeStep'); });
var GenderStep = lazy(function () { return import('./pages/GenderStep'); });
var InfoStep = lazy(function () { return import('./pages/InfoStep'); });
var HeadphoneCheckStep = lazy(function () { return import('./pages/HeadphoneCheckStep'); });
var VolumeStep = lazy(function () { return import('./pages/VolumeStep'); });
var InstructionsStep = lazy(function () { return import('./pages/InstructionsStep'); });
var DinTestPage = lazy(function () { return import('./pages/DinTestPage'); });
var ScoreGraphPage = lazy(function () { return import('./pages/ScoreGraphPage'); });
var ResultCategoryPage = lazy(function () { return import('./pages/ResultCategoryPage'); });
export var appRoutes = [
    {
        path: '/hearing-aid-options',
        element: _jsx(HearingAidOptionsPage, {}),
    },
    {
        path: '/hearing-aid-simulator',
        element: _jsx(HearingAidSimulatorPage, {}),
    },
    { path: '/', element: _jsx(WelcomePage, {}) },
    {
        path: '/setup',
        element: _jsx(SetupPage, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/setup/select-your-birth-year", replace: true }),
            },
            { path: 'select-your-birth-year', element: _jsx(AgeStep, {}) },
            { path: 'select-your-gender', element: _jsx(GenderStep, {}) },
            { path: 'info', element: _jsx(InfoStep, {}) },
            { path: 'headphone-check', element: _jsx(HeadphoneCheckStep, {}) },
            { path: 'volume', element: _jsx(VolumeStep, {}) },
            { path: 'instructions', element: _jsx(InstructionsStep, {}) },
        ],
    },
    { path: '/din-test', element: _jsx(Navigate, { to: "/din-test/1", replace: true }) },
    { path: '/din-test/:id', element: _jsx(DinTestPage, {}) },
    { path: '/score-graph', element: _jsx(ScoreGraphPage, {}) },
    { path: '/result-category/:category', element: _jsx(ResultCategoryPage, {}) },
    {
        path: '/index.html',
        element: _jsx(Navigate, { to: "/", replace: true }),
    },
];
